import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RxAlertsCount {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  RxAlertsCountData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: RxAlertsCount = {
  isLoading: false,
  error: false,
  message: null,
  RxAlertsCountData: [],
  Items: [],
  Pagination: [],
};

const RxAlertsCountSlice = createSlice({
  name: "RxAlertsCount",
  initialState,
  reducers: {
    loadingRxAlertsCount: (state: RxAlertsCount, action: PayloadAction<{}>) => {
      state.isLoading = true;
    },
    setRxAlertsCount: (state: any, action: PayloadAction<RxAlertsCount>) => {
      return action.payload;
    },
  },
});

export const { loadingRxAlertsCount, setRxAlertsCount } =
  RxAlertsCountSlice.actions;
export default RxAlertsCountSlice.reducer;
